import { render, staticRenderFns } from "./HeroesComicsGrid.vue?vue&type=template&id=ab3eccc8&lang=pug&"
import script from "./HeroesComicsGrid.vue?vue&type=script&lang=js&"
export * from "./HeroesComicsGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
installComponents(component, {VCardText,VContainer,VFlex,VLayout,VProgressLinear})
